module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_maedori@2x-c45189a05d90fa3851fbd132441f43ed.webp";